<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import SiteIdentitySectionEditor from "./partials/site-identity-section.vue";
import siteIdentityApi from "@/helpers/site-identity/site-identity-api.js";

const SECTION_TABS = [
  { key: "institutional_logos", titleKey: "institutional" },
  { key: "anexo_logos", titleKey: "anexoLogos" },
  { key: "main_logo", titleKey: "mainLogo" },
  { key: "login_banner", titleKey: "loginBanner" },
];

export default {
  page: {
    title: "Identidad del sitio",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    SiteIdentitySectionEditor,
  },
  data() {
    return {
      title: this.$t("siteIdentity.title"),
      activeTab: 0,
      sections: {},
      loading: true,
      sectionTabs: SECTION_TABS,
    };
  },
  mounted() {
    this.loadIdentity();
  },
  methods: {
    tabTitle(tab) {
      return this.$t(`siteIdentity.tabs.${tab.titleKey}`);
    },
    async loadIdentity() {
      this.loading = true;

      try {
        const response = await siteIdentityApi.getAdmin();
        this.sections = response?.data?.data || {};
      } catch (error) {
        this.$bvToast.toast("No se pudo cargar la identidad del sitio", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    onSectionSaved() {
      this.loadIdentity();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <b-spinner />
        </div>

        <b-tabs v-else v-model="activeTab" pills card>
          <b-tab
            v-for="tab in sectionTabs"
            :key="tab.key"
            :title="tabTitle(tab)"
          >
            <SiteIdentitySectionEditor
              v-if="sections[tab.key]"
              :section-key="tab.key"
              :section-config="sections[tab.key]"
              @saved="onSectionSaved"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
